/**
 * MakeLoveLocks — Scroll Animations & Header Behavior
 */

(function () {
  "use strict";

  // Intersection Observer for fade-up animations
  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          fadeObserver.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px",
    },
  );

  // Observe all animated elements
  document.querySelectorAll(".mll-fade-up, .mll-stagger").forEach((el) => {
    fadeObserver.observe(el);
  });

  // Transparent header on hero sections
  const headerSection = document.querySelector(".section-header");
  const hero = document.querySelector(".mll-hero");

  if (headerSection && hero) {
    // Get all header-group sections for solid/transparent toggling
    const headerGroups = document.querySelectorAll(".shopify-section-group-header-group");
    const totalHeaderHeight = Array.from(headerGroups).reduce((h, el) => h + el.offsetHeight, 0);

    function updateHeader() {
      const scrollY = window.scrollY || window.pageYOffset;
      const heroBottom = hero.offsetHeight - totalHeaderHeight;

      if (scrollY > heroBottom) {
        headerSection.classList.add("mll-header--solid");
        headerSection.classList.remove("mll-header--transparent");
      } else {
        headerSection.classList.add("mll-header--transparent");
        headerSection.classList.remove("mll-header--solid");
      }
    }

    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
  }
})();
